import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const usePaymentRequestSupportAgentFlag = () =>
  useBooleanFlagValue('payment-request-support-agent', false);
